import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

export type TagTypesTy = 'buyOrder' | 'buyDeliveryNote' | 'buyInvoice' | 'sellOrder' | 'sellDeliveryNote' | 'sellInvoice'
const useTagTypes = () => {
    const { t } = useTwinTranslation()
    const tagTypes: Record<TagTypesTy, TwinDictionary> = {
        'buyOrder': { name: t('buyOrdersL', 'Pedido de compras'), url: '/api/app/order/buy/buyOrder/printBuyOrderTags' },
        'buyDeliveryNote': { name: t('buyDeliveryNotesL', 'Albarán de compras'), url: '/api/app/order/buy/buyDeliveryNote/printBuyDeliveryNoteTags' },
        'buyInvoice': { name: t('buyInvoicesL', 'Factura de compras'), url: '/api/app/order/buy/buyInvoice/printBuyInvoiceTags' },
        'sellOrder': { name: t('sellOrder', 'Pedido'), url: '/api/app/order/sell/sellOrder/printSellOrderTags' },
        'sellDeliveryNote': { name: t('sellDeliveryNote', 'Albarán de venta'), url: '/api/app/order/sell/sellDeliveryNote/printSellDeliveryNoteTags' },
        'sellInvoice': { name: t('sellInvoice', 'Factura de venta'), url: '/api/app/order/sell/sellInvoice/printSellInvoiceTags' },
    }
    return { tagTypes }
}

export default useTagTypes